import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { initializeApollo, addApolloState } from '@utils/apollo'
import { getGiftCards } from '@gql/giftCardQuery'

import GiftCardHomeModule from '@modules/GiftCard/Home'

function GiftCardPage() {
  return <GiftCardHomeModule />
}

/**
 *
 * @param {import('next').GetStaticPropsContext} ctx
 * @returns {import('next').GetStaticPropsResult}
 */
export async function getStaticProps(ctx) {
  const client = initializeApollo(undefined, ctx)

  await client.query({
    query: getGiftCards,
  })

  return addApolloState(client, {
    props: {
      ...(await serverSideTranslations(ctx.locale, [
        'common',
        'giftCardLandingPage',
      ])),
    },
  })
}

GiftCardPage.getLayout = GiftCardHomeModule.getLayout

export default GiftCardPage
